var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7495 19.25V11.9167C13.7495 11.6736 13.6529 11.4404 13.481 11.2685C13.3091 11.0966 13.076 11 12.8328 11H9.16618C8.92306 11 8.68991 11.0966 8.518 11.2685C8.34609 11.4404 8.24951 11.6736 8.24951 11.9167V19.25",
    stroke: "#FFFDF1",
    strokeWidth: 2.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75049 9.16733C2.75042 8.90064 2.80854 8.63715 2.92079 8.39523C3.03304 8.15332 3.19672 7.93881 3.40041 7.76666L9.81707 2.26758C10.148 1.98791 10.5672 1.83447 11.0005 1.83447C11.4337 1.83447 11.853 1.98791 12.1839 2.26758L18.6006 7.76666C18.8043 7.93881 18.9679 8.15332 19.0802 8.39523C19.1924 8.63715 19.2506 8.90064 19.2505 9.16733V17.4173C19.2505 17.9036 19.0573 18.3699 18.7135 18.7137C18.3697 19.0575 17.9034 19.2507 17.4172 19.2507H4.58382C4.09759 19.2507 3.63128 19.0575 3.28746 18.7137C2.94364 18.3699 2.75049 17.9036 2.75049 17.4173V9.16733Z",
    stroke: "#FFFDF1",
    strokeWidth: 2.29167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4540c8ed1e7b8a8ef255488bb6403ee3.svg";
export { ForwardRef as ReactComponent };